import writeXlsxFile from "write-excel-file";
import { getDateForDownload, getDateWithoutTimestamp } from "../helperFuncs";

const mileageBands = [
  "1 - 10",
  "11 - 20",
  "21 - 30",
  "31 - 40",
  "41 - 50",
  "51 - 60",
  "61 - 70",
  "71 - 80",
  "81 - 90",
  "91 - 100",
  "101 - 110",
  "111 - 120",
  "121 - 130",
  "131 - 140",
  "141 - 150",
  "151 - 160",
  "161 - 170",
  "171 - 180",
  "181 - 190",
  "191 - 200",
  "201 - 210",
  "211 - 220",
  "221 - 230",
  "231 - 240",
  "241 - 250",
  "251 - 260",
  "261 - 270",
  "271 - 280",
  "281 - 290",
  "291 - 300",
];

const ErrorHandler = (error) => {
  return error.message;
};

const DeliveredOn = (d) => {
  try {
    var newD = getDateForDownload(d);
    return newD;
  } catch (error) {
    return ErrorHandler(error);
  }
};

const getMileageBand = (m) => {
  if (m < 1) {
    return mileageBands[0];
  }
  try {
    let rounded = Math.round(m);
    return mileageBands[Math.floor((rounded - 1) / 10)];
  } catch (error) {
    return "Not Found";
  }
};

const SandNetWeight = (sandPOs, load, projects) => {
  let moistureWeight = 0;
  let netWeight = 0;
  var po;
  if (!projects) {
    po = sandPOs.filter((x) => x.po_number === load.po_number);
  } else {
    po = sandPOs.filter(
      (x) => x.po_number === load.po_number && x.project_id === load.project_id,
    );
  }
  if (po.length > 0) {
    moistureWeight = (load.weight_tons * po[0].moistuire_content_rev) / 100;
    netWeight = load.weight_tons - moistureWeight;
  }
  return [moistureWeight, netWeight];
};

const getRateFromMethod = (
  methodId,
  weight,
  mileage,
  cost,
  rev,
  isCustomer,
) => {
  var rate;
  if (isCustomer) {
    switch (methodId) {
      case 7:
        if (weight > 0) rate = rev / weight;
        break;
      case 8:
        rate = rev;
        break;
      case 40:
        if (mileage > 0) {
          rate = rev / mileage;
        }
        break;
      default:
        rate = 0;
    }
  } else {
    switch (methodId) {
      case 7:
        if (weight > 0) rate = cost / weight;
        break;
      case 8:
        rate = cost;
        break;
      case 40:
        if (mileage > 0) {
          rate = cost / mileage;
        }
        break;
      default:
        rate = 0;
    }
  }
  return rate;
};

export const GenerateCustomerDownload = async (
  invoice,
  invoiceLoads,
  jobName,
  customerName,
  projects,
  adjustments,
  sandPOs,
  invoiceTotals,
  methodId,
) => {
  if (invoice && invoiceLoads && (jobName || customerName)) {
    // replace periods from job name and invoice name
    var fileName, poHeader;
    const invName = invoice.invoice_name.replace(/\./g, "-");
    if (jobName) {
      const newJobName = jobName.replace(/\./g, "-");
      fileName = `${newJobName} - ${invName}`;
    } else {
      const newCustomerName = customerName.replace(/\./g, "-");
      fileName = `${newCustomerName} - ${invName}`;
    }

    // get terminal information
    var loadRows = [];
    var poRows = [];
    let terminalMileages = {};
    let uniquePOs = [];
    let PoValues = [];
    let terminalValues = [];
    let totals = {
      total_loads: 0,
      total_sand_loads: 0,
      total_sand_hauling_weight: 0,
      total_fsc_rev: 0,
      total_freight_rev: 0,
      total_rev: 0,
      total_sand_weight: 0,
      total_moisture_weight: 0,
      total_net_weight: 0,
      total_sand_rev: 0,
    };

    const columns = [
      { width: 10 },
      { width: 40 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 40 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
    ];
    const blankRow = [{}];
    const data = [blankRow];
    const freightLoadHeader = [
      {
        value: "Terminal",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Product",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "PO Number",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Ticket No",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];

    const primaryLoadHeader = [
      {
        value: "Approved Mileage",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Net Weight (tons)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Freight ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Fuel Surcharge ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];

    const sandLoadHeader = [
      {
        value: "Gross Sand Weight (tons)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Moisture Weight (tons)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Net Sand Weight (tons)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Sand Cost ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];

    // loads
    var loadsHeader;
    if (!projects) {
      loadsHeader = [
        {},
        {
          value: "Load No",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Delivery Date",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
      ];
      if (!invoice.is_asset) {
        loadsHeader.push(...freightLoadHeader);
      }
    } else {
      loadsHeader = [
        {},
        {
          value: "Load No",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Job Name",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Delivery Date",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
      ];
      if (!invoice.is_asset) {
        loadsHeader.push(...freightLoadHeader);
      }
    }
    if (invoiceTotals.freight_rev > 0) {
      loadsHeader.push(...primaryLoadHeader);
    }
    if (invoiceTotals.sand_rev > 0) {
      loadsHeader.push(...sandLoadHeader);
    }

    loadsHeader.push({
      value: "Gross ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    });

    invoiceLoads.forEach((load) => {
      let moistureWeight = 0;
      let netSandweight = 0;
      if (!invoice.is_asset && sandPOs && invoiceTotals.sand_rev > 0) {
        [moistureWeight, netSandweight] = SandNetWeight(
          sandPOs,
          load,
          projects,
        );
      }
      let delivered = DeliveredOn(load.delivered_date);
      let newLoad = [
        {},
        {
          value: load.load_no,
          fontSize: 12,
          align: "center",
        },
      ];

      if (projects) {
        newLoad.push({
          value: projects.filter((x) => x.id === load.project_id)[0].job_name,
          fontSize: 12,
          align: "center",
        });
      }
      newLoad.push({
        value: delivered,
        fontSize: 12,
        align: "center",
      });

      let freightLoad = [
        {
          value: load.terminal_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.product_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.po_number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.ticket_number,
          fontSize: 12,
          align: "center",
        },
      ];

      totals.total_loads = totals.total_loads + 1;
      totals.total_sand_hauling_weight =
        totals.total_sand_hauling_weight + load.weight_tons;
      totals.total_freight_rev = totals.total_freight_rev + load.freight_rev;
      totals.total_fsc_rev = totals.total_fsc_rev + load.fsc_rev;
      totals.total_rev = totals.total_rev + load.freight_rev + load.fsc_rev;
      if (!invoice.is_asset) {
        newLoad.push(...freightLoad);
        if (load.sand_rev !== 0) {
          if (!uniquePOs.includes(load.po_number)) {
            uniquePOs.push(load.po_number);
            PoValues.push({
              po_number: load.po_number,
              terminal_name: load.terminal_name,
              product_name: load.product_name,
              loads: 0,
              weight_tons: 0,
              moisture_weight: 0,
              net_weight: 0,
              rev_per_ton: 0,
              sand_rev: 0,
            });
          }
          const poIdx = PoValues.findIndex(
            (x) => x.po_number === load.po_number,
          );
          if (poIdx !== -1) {
            PoValues[poIdx].weight_tons =
              PoValues[poIdx].weight_tons + load.weight_tons;
            PoValues[poIdx].sand_rev = PoValues[poIdx].sand_rev + load.sand_rev;
            PoValues[poIdx].loads = PoValues[poIdx].loads + 1;
            PoValues[poIdx].moisture_weight =
              PoValues[poIdx].moisture_weight + moistureWeight;
            PoValues[poIdx].net_weight =
              PoValues[poIdx].net_weight + netSandweight;
            totals.total_sand_weight =
              totals.total_sand_weight + load.weight_tons;
            totals.total_sand_rev = totals.total_sand_rev + load.sand_rev;
            totals.total_sand_loads = totals.total_sand_loads + 1;
            totals.total_moisture_weight =
              totals.total_moisture_weight + moistureWeight;
            totals.total_net_weight = totals.total_net_weight + netSandweight;
            totals.total_rev = totals.total_rev + load.sand_rev;
          }
        }
      }
      if (invoiceTotals.freight_rev > 0) {
        let primaryLoad = [
          {
            value: load.mileage,
            fontSize: 12,
            align: "center",
          },
          {
            value: parseFloat(load.weight_tons.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.freight_rev.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.fsc_rev.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
        ];
        newLoad.push(...primaryLoad);
      }
      if (!invoice.is_asset && invoiceTotals.sand_rev > 0 && sandPOs) {
        let sandLoad = [
          {
            value: parseFloat(load.weight_tons.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(moistureWeight.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(netSandweight.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.sand_rev.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
        ];
        newLoad.push(...sandLoad);
      }
      newLoad.push({
        value: parseFloat(load.total_rev.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
      });
      loadRows.push(newLoad);
      var mileageBand = getMileageBand(load.mileage);
      if (invoiceTotals.freight_rev > 0) {
        if (!terminalMileages[mileageBand]) {
          terminalMileages[mileageBand] = [
            {
              mileage: load.mileage,
              loads: 1,
              weight: load.weight_tons,
              freight_rev_per_ton: 0,
              freight: load.freight_rev,
              fsc_rev_per_ton: 0,
              unique_freight_rate: getRateFromMethod(
                7,
                load.weight_tons,
                load.mileage,
                load.freight_rev,
              ).toFixed(2),
              unique_fsc_rate: getRateFromMethod(
                methodId,
                load.weight_tons,
                load.mileage,
                load.fsc_rev,
              ).toFixed(2),
              fsc: load.fsc_rev,
              total: load.freight_rev + load.fsc_rev,
            },
          ];
        } else {
          const m = terminalMileages[load.terminal_name].filter(
            (x) =>
              x.mileage === load.mileage &&
              load.weight_tons > 0 &&
              getRateFromMethod(
                methodId,
                load.weight_tons,
                load.mileage,
                load.fsc_rev,
              ).toFixed(2) === x.unique_fsc_rate &&
              getRateFromMethod(
                7,
                load.weight_tons,
                load.mileage,
                load.freight_rev,
              ).toFixed(2) === x.unique_freight_rate,
          );
          if (m.length > 0) {
            m[0].loads = m[0].loads + 1;
            m[0].weight = m[0].weight + load.weight_tons;
            m[0].freight = m[0].freight + load.freight_rev;
            m[0].fsc = m[0].fsc + load.fsc_rev;
            m[0].total = m[0].total + load.freight_rev + load.fsc_rev;
          } else {
            terminalMileages[load.terminal_name].push({
              mileage: load.mileage,
              loads: 1,
              weight: load.weight_tons,
              freight_rev_per_ton: 0,
              freight: load.freight_rev,
              fsc_rev_per_ton: 0,
              unique_freight_rate: getRateFromMethod(
                7,
                load.weight_tons,
                load.mileage,
                load.freight_rev,
              ).toFixed(2),
              unique_fsc_rate: getRateFromMethod(
                methodId,
                load.weight_tons,
                load.mileage,
                load.fsc_rev,
              ).toFixed(2),
              fsc: load.fsc_rev,
              total: load.freight_rev + load.fsc_rev,
            });
          }
        }
      }
    });

    data.push([
      {},
      {
        value: "Invoice Totals",
        fontWeight: "bold",
        fontSize: 20,
        align: "center",
        span: 3,
      },
    ]);
    const invTotalsHeader = [
      {},
      {
        value: "Gross $",
        fontWeight: "bold",
        fontSize: 15,
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Adjustments $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Net $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
    ];

    data.push(invTotalsHeader);
    const invTotals = [
      {},
      {
        value: parseFloat(totals.total_rev.toFixed(2)),
        fontSize: 12,
        type: Number,
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value:
          adjustments && adjustments.invoice_adjustment
            ? parseFloat(adjustments.invoice_adjustment.total_adjustment)
            : 0,
        fontSize: 12,
        type: Number,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value:
          adjustments && adjustments.invoice_adjustment
            ? parseFloat(
                (
                  totals.total_rev +
                  parseFloat(adjustments.invoice_adjustment.total_adjustment)
                ).toFixed(2),
              )
            : parseFloat(totals.total_rev.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
    ];
    data.push(invTotals);

    if (terminalMileages && Object.keys(terminalMileages).length > 0) {
      data.push(blankRow);
      data.push([
        {},
        {
          value: "Terminal Mileages",
          fontWeight: "bold",
          fontSize: 20,
          align: "center",
          span: 9,
        },
      ]);
      data.push([
        {},
        {
          value: "Terminal",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "Mileage Band",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "Loads",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "Weight",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "Freight Rate $",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "Freight $",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "FSC Rate $",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "FSC $",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "Total $",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
      ]);
      var allTerminalTotals = {
        loads: 0,
        weight: 0,
        freight_rev_per_ton: "",
        freight: 0,
        fsc_rev_per_ton: "",
        fsc: 0,
        total: 0,
      };
      for (const [key, val] of Object.entries(terminalMileages)) {
        let totals = {
          mileage: "",
          loads: 0,
          weight: 0,
          freight_rev_per_ton: "",
          freight: 0,
          fsc_rev_per_ton: "",
          fsc: 0,
          total: 0,
        };
        for (let i = 0; i < val.length; i++) {
          allTerminalTotals.loads = allTerminalTotals.loads + val[i].loads;
          allTerminalTotals.weight = allTerminalTotals.weight + val[i].weight;
          allTerminalTotals.freight =
            allTerminalTotals.freight + val[i].freight;
          allTerminalTotals.fsc = allTerminalTotals.fsc + val[i].fsc;
          allTerminalTotals.total = allTerminalTotals.total + val[i].total;

          totals.loads = totals.loads + val[i].loads;
          totals.weight = totals.weight + val[i].weight;
          totals.freight = totals.freight + val[i].freight;
          totals.fsc = totals.fsc + val[i].fsc;
          totals.total = totals.total + val[i].total;
          // if (val[i].weight > 0) {
          //   val[i].freight_rev_per_ton = val[i].freight / val[i].weight;
          // }
          val[i].fsc_rev_per_ton = parseFloat(val[i].unique_fsc_rate);
          val[i].freight_rev_per_ton = parseFloat(val[i].unique_freight_rate);
          let newRow = [];
          if (i === 0) {
            newRow.push(
              {},
              {
                value: key,
                fontSize: 12,
                align: "center",
                leftBorderStyle: "thin",
                topBorderStyle: "thin",
                bottomBorderStyle: "thin",
                rightBorderStyle: "thin",
              },
            );
          } else {
            newRow.push(
              {},
              {
                value: "",
                fontSize: 12,
                align: "center",
                leftBorderStyle: "thin",
                topBorderStyle: "thin",
                bottomBorderStyle: "thin",
                rightBorderStyle: "thin",
              },
            );
          }
          for (const [k, v] of Object.entries(val[i])) {
            if (k === "mileage") {
              newRow.push({
                value: v,
                fontSize: 12,
                align: "center",
                topBorderStyle: "thin",
                bottomBorderStyle: "thin",
                rightBorderStyle: "thin",
              });
            } else if (k !== "unique_fsc_rate" && k !== "unique_freight_rate") {
              newRow.push({
                value: parseFloat(v.toFixed(2)),
                fontSize: 12,
                type: Number,
                align: "center",
                topBorderStyle: "thin",
                bottomBorderStyle: "thin",
                rightBorderStyle: "thin",
              });
            }
          }
          data.push(newRow);
          var totalRow = [];
          totalRow.push(
            {},
            {
              value: `${key} - Totals`,
              fontSize: 12,
              align: "center",
              fontWeight: "bold",
              leftBorderStyle: "thin",
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
            },
          );
          for (const [k, t] of Object.entries(totals)) {
            if (t !== "") {
              if (k === "loads") {
                totalRow.push({
                  value: t,
                  fontSize: 12,
                  fontWeight: "bold",
                  align: "center",
                  topBorderStyle: "thin",
                  bottomBorderStyle: "thin",
                  rightBorderStyle: "thin",
                });
              } else {
                totalRow.push({
                  value: parseFloat(t.toFixed(2)),
                  fontSize: 12,
                  type: Number,
                  fontWeight: "bold",
                  align: "center",
                  topBorderStyle: "thin",
                  bottomBorderStyle: "thin",
                  rightBorderStyle: "thin",
                });
              }
            } else {
              totalRow.push({
                value: t,
                fontSize: 12,
                align: "center",
                topBorderStyle: "thin",
                bottomBorderStyle: "thin",
                rightBorderStyle: "thin",
              });
            }
          }
        }
        data.push(totalRow);
      }
      var allTerminalTotalRow = [];
      allTerminalTotalRow.push(
        {},
        {
          value: "Totals",
          fontSize: 14,
          align: "center",
          fontWeight: "bold",
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
        {
          value: "",
          fontSize: 14,
          align: "center",
          fontWeight: "bold",
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
      );
      for (const [, at] of Object.entries(allTerminalTotals)) {
        if (at === "") {
          allTerminalTotalRow.push({
            value: "",
            fontSize: 14,
            align: "center",
            fontWeight: "bold",
            leftBorderStyle: "thin",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          });
        } else {
          allTerminalTotalRow.push({
            value: parseFloat(at.toFixed(2)),
            type: Number,
            fontSize: 14,
            align: "center",
            fontWeight: "bold",
            leftBorderStyle: "thin",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          });
        }
      }
      data.push(allTerminalTotalRow);
    }

    if (!invoice.is_asset) {
      // update terminal $/ton values
      terminalValues.forEach((t) => {
        if (t.total_hauling_weight > 0) {
          t.freight_rev_per_ton = t.total_freight_rev / t.total_hauling_weight;
          t.fsc_rev_per_ton = t.total_fsc / t.total_hauling_weight;
        }
        if (t.total_loads > 0) {
          t.freight_rev_per_load = t.total_freight_rev / t.total_loads;
          t.fsc_rev_per_load = t.total_fsc / t.total_loads;
        }
      });
      PoValues.forEach((po) => {
        if (po.weight_tons > 0) {
          po.rev_per_ton = po.sand_rev / po.net_weight;
        }
      });
      data.push(blankRow);

      if (uniquePOs.length > 0) {
        data.push(blankRow, blankRow);
        data.push([
          {},
          {
            value: "PO Totals",
            fontWeight: "bold",
            fontSize: 20,
            align: "center",
            span: 9,
          },
        ]);
        poHeader = [
          {},
          {
            value: "PO",
            fontWeight: "bold",
            fontSize: 15,
            leftBorderStyle: "thin",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: "Terminal",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            rightBorderStyle: "thin",
            bottomBorderStyle: "thin",
            align: "center",
          },
          {
            value: "Sand Type",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            rightBorderStyle: "thin",
            bottomBorderStyle: "thin",
            align: "center",
          },
          {
            value: "Loads",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            rightBorderStyle: "thin",
            bottomBorderStyle: "thin",
            align: "center",
          },
          {
            value: "Gross Weight",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            rightBorderStyle: "thin",
            bottomBorderStyle: "thin",
            align: "center",
          },
          {
            value: "Moisture Weight",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            rightBorderStyle: "thin",
            bottomBorderStyle: "thin",
            align: "center",
          },
          {
            value: "Net Weight",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: "$/Ton",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: "Total $",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
        ];
        PoValues.forEach((po) => {
          let newPO = [
            {},
            {
              value: po.po_number,
              fontSize: 12,
              leftBorderStyle: "thin",
              align: "center",
              rightBorderStyle: "thin",
              fontWeight: "bold",
            },
            {
              value: po.terminal_name,
              fontSize: 12,
              align: "center",
              rightBorderStyle: "thin",
            },
            {
              value: po.product_name,
              fontSize: 12,
              align: "center",
              rightBorderStyle: "thin",
            },
            {
              value: po.loads,
              fontSize: 12,
              type: Number,
              align: "center",
              rightBorderStyle: "thin",
            },
            {
              value: parseFloat(po.weight_tons.toFixed(2)),
              fontSize: 12,
              type: Number,
              align: "center",
              rightBorderStyle: "thin",
            },
            {
              value: parseFloat(po.moisture_weight.toFixed(2)),
              fontSize: 12,
              type: Number,
              align: "center",
              rightBorderStyle: "thin",
            },
            {
              value: parseFloat(po.net_weight.toFixed(2)),
              fontSize: 12,
              type: Number,
              align: "center",
              rightBorderStyle: "thin",
            },
            {
              value: parseFloat(po.rev_per_ton.toFixed(2)),
              fontSize: 12,
              type: Number,
              align: "center",
              rightBorderStyle: "thin",
            },
            {
              value: parseFloat(po.sand_rev.toFixed(2)),
              fontSize: 12,
              type: Number,
              align: "center",
              rightBorderStyle: "thin",
            },
          ];
          poRows.push(newPO);
        });

        poRows.push([
          {},
          {
            value: "Totals",
            fontWeight: "bold",
            fontSize: 13,
            leftBorderStyle: "thin",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          },
          {
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          },
          {
            value: totals.total_sand_loads,
            fontWeight: "bold",
            fontSize: 13,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(totals.total_sand_weight.toFixed(2)),
            fontWeight: "bold",
            fontSize: 13,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(totals.total_moisture_weight.toFixed(2)),
            fontWeight: "bold",
            fontSize: 13,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(totals.total_net_weight.toFixed(2)),
            fontWeight: "bold",
            fontSize: 13,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          },
          {
            value: parseFloat(totals.total_sand_rev.toFixed(2)),
            fontWeight: "bold",
            fontSize: 13,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            align: "center",
            rightBorderStyle: "thin",
          },
        ]);
        data.push(poHeader);
        data.push(...poRows);
      }
    }

    if (adjustments && adjustments.adjustment_fields) {
      data.push(blankRow, blankRow);
      data.push([
        {},
        {
          value: "Adjustments",
          fontWeight: "bold",
          fontSize: 20,
          align: "center",
          span: 5,
        },
      ]);
      data.push([
        {},
        {
          value: "Item",
          fontWeight: "bold",
          fontSize: 15,
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Type",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Amount $",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Date",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Comments",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          align: "center",
        },
      ]);
      adjustments.adjustment_fields.forEach((f) => {
        let adjDate = getDateWithoutTimestamp(f.date_of_adjustment);
        data.push([
          {},
          {
            value: f.field_name,
            fontSize: 12,
            leftBorderStyle: "thin",
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: f.is_credit ? "Credit" : "Charge",
            fontSize: 12,
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: parseFloat(f.field_value),
            fontSize: 12,
            type: Number,
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: adjDate,
            fontSize: 12,
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: f.adjustment_comments,
            fontSize: 12,
            align: "center",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          },
        ]);
      });
      data.push([
        {},
        {
          value: "Total",
          fontSize: 15,
          leftBorderStyle: "thin",
          align: "center",
          fontWeight: "bold",
          bottomBorderStyle: "thin",
        },
        { bottomBorderStyle: "thin" },
        {
          value: parseFloat(adjustments.invoice_adjustment.total_adjustment),
          fontSize: 15,
          fontWeight: "bold",
          type: Number,
          align: "center",
          bottomBorderStyle: "thin",
        },
        {
          bottomBorderStyle: "thin",
        },
        {
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
      ]);
    }
    var loadColumnLen = 0;
    let loadTotals;
    if (!projects) {
      loadTotals = [
        {
          value: "Totals",
          fontSize: 12,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: totals.total_loads,
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
      ];
      loadColumnLen = 2;
    } else {
      loadTotals = [
        {
          value: "Totals",
          fontSize: 12,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: totals.total_loads,
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
        {},
      ];
      loadColumnLen = 3;
    }
    const freightTotalGap = [{}, {}, {}, {}];
    if (!invoice.is_asset) {
      loadTotals.push(...freightTotalGap);
      loadColumnLen += 4;
    }
    loadTotals.push({});
    loadColumnLen += 1;

    if (invoiceTotals.freight_rev > 0) {
      loadTotals.push(
        {},
        {
          value: parseFloat(totals.total_sand_hauling_weight.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: parseFloat(totals.total_freight_rev.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: parseFloat(totals.total_fsc_rev.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
      );
      loadColumnLen += 5;
    }

    if (invoiceTotals.sand_rev > 0) {
      loadTotals.push(
        {
          value: parseFloat(totals.total_sand_weight.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: parseFloat(totals.total_moisture_weight.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: parseFloat(totals.total_net_weight.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: parseFloat(totals.total_sand_rev.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
      );
      loadColumnLen += 4;
    }
    loadTotals.push({
      value: parseFloat(totals.total_rev.toFixed(2)),
      fontSize: 12,
      type: Number,
      align: "center",
      fontWeight: "bold",
    });

    data.push(blankRow, blankRow, blankRow, blankRow);
    data.push([
      {},
      {
        value: "Invoiced Loads",
        fontWeight: "bold",
        fontSize: 20,
        align: "center",
        span: loadColumnLen,
      },
    ]);
    data.push(loadsHeader, ...loadRows);

    data.push(loadTotals);
    await writeXlsxFile(data, {
      columns,
      fileName,
    });
  }
};

export const GenerateTierFreightDownload = async (
  invoice,
  invoiceLoads,
  customerName,
) => {
  if (invoice && invoiceLoads) {
    // replace periods from job name and invoice name

    const invName = invoice.invoice_name.replace(/\./g, "-");
    const fileName = `${customerName} - ${invName}`;
    // get terminal information

    let totals = {
      loads: 0,
      weight_tons: 0,
      freight_rev: 0,
      project_inv_rev: 0,
      total_rev: 0,
    };

    let mileageTotals = {};

    let projectTotals = {
      0: {
        loads: 0,
        weight: 0,
        cost: 0,
      },
    };
    let projectIds = [];

    const columns = [
      { width: 10 },
      { width: 30 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 20 },
      { width: 20 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 20 },
    ];
    const blankRow = [{}];
    const totalsHeader = [
      {},
      {
        value: "Mileage Band",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        leftBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Total Tier Loads",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Total Tier Tons",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Tier Hauling $/Ton",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Tier Cost ($)",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
    ];

    const data = [blankRow, totalsHeader];

    // loads
    const loadsHeader = [
      {},
      {
        value: "Load No",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Job",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Delivery Date",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Terminal",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Product",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "PO Number",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Ticket No",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Approved Mileage",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Net Weight (tons)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: " Weekly Billed ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "EOM Tier Calc ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Total ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];

    const loadsData = [];

    invoiceLoads.forEach((load) => {
      let delivered = DeliveredOn(load.delivered_date);
      let newLoad;
      const key = Object.keys(mileageBands).find(
        (x) =>
          mileageBands[x].low <= load.mileage &&
          mileageBands[x].high >= load.mileage,
      );
      if (!(key in mileageTotals)) {
        mileageTotals[key] = [
          {
            loads: 1,
            weight: load.weight_tons,
            rate: getRateFromMethod(
              7,
              load.weight_tons,
              load.mileage,
              load.freight_cost,
              load.freight_rev,
              true,
            ).toFixed(2),
            cost: parseFloat(load.freight_rev.toFixed(2)),
          },
        ];
      } else {
        let rateExists = mileageTotals[key].filter(
          (x) =>
            x.rate ===
            getRateFromMethod(
              7,
              load.weight_tons,
              load.mileage,
              load.freight_cost,
              load.freight_rev,
              true,
            ).toFixed(2),
        );
        if (rateExists.length > 0) {
          rateExists[0].loads = rateExists[0].loads + 1;
          rateExists[0].weight = rateExists[0].weight + load.weight_tons;
          rateExists[0].cost =
            rateExists[0].cost + parseFloat(load.freight_rev.toFixed(2));
        } else {
          mileageTotals[key].push({
            loads: 1,
            weight: load.weight_tons,
            rate: getRateFromMethod(
              7,
              load.weight_tons,
              load.mileage,
              load.freight_cost,
              load.freight_rev,
              true,
            ).toFixed(2),
            cost: parseFloat(load.freight_rev.toFixed(2)),
          });
        }
      }
      if (!projectTotals[load.project_id]) {
        projectTotals[load.project_id] = {
          loads: 1,
          project_name: load.project_name,
          weight: load.weight_tons,
          cost: load.freight_rev,
        };
        projectIds.push(load.project_id);
      } else {
        projectTotals[load.project_id].loads =
          projectTotals[load.project_id].loads + 1;
        projectTotals[load.project_id].weight =
          projectTotals[load.project_id].weight + load.weight_tons;
        projectTotals[load.project_id].cost =
          projectTotals[load.project_id].cost + load.freight_rev;
      }
      projectTotals[0].loads = projectTotals[0].loads + 1;
      projectTotals[0].weight = projectTotals[0].weight + load.weight_tons;
      projectTotals[0].cost = projectTotals[0].cost + load.freight_rev;
      newLoad = [
        {},
        {
          value: load.load_no,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.project_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: delivered,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.terminal_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.product_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.po_number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.ticket_number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.mileage,
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.weight_tons.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
        {
          value: parseFloat(load.project_inv_rev.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
        {
          value: parseFloat(load.freight_rev.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
        {
          value: parseFloat(load.total_rev.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
      ];

      totals.loads = totals.loads + 1;
      totals.weight_tons = totals.weight_tons + load.weight_tons;
      totals.freight_rev = totals.freight_rev + load.freight_rev;
      totals.project_inv_rev = totals.project_inv_rev + load.project_inv_rev;
      totals.total_rev = totals.total_rev + load.total_rev;

      loadsData.push(newLoad);
    });

    for (const [k, v] of Object.entries(mileageTotals)) {
      v.forEach((rate, i) => {
        let newRow = [{}];
        if (i === 0) {
          newRow.push({
            value: k,
            fontSize: 12,
            leftBorderStyle: "thin",
            bottomBorderStyle: "thin",
            align: "center",
          });
        } else {
          newRow.push({
            value: "",
            fontSize: 12,
            leftBorderStyle: "thin",
            bottomBorderStyle: "thin",
            align: "center",
          });
        }
        for (const [key, val] of Object.entries(rate)) {
          if (key === "loads") {
            newRow.push({
              value: val,
              fontSize: 12,
              bottomBorderStyle: "thin",
              leftBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            });
          } else if (key === "rate") {
            newRow.push({
              value: parseFloat(val),
              fontSize: 12,
              type: Number,
              bottomBorderStyle: "thin",
              leftBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            });
          } else {
            newRow.push({
              value: parseFloat(val.toFixed(2)),
              fontSize: 12,
              type: Number,
              bottomBorderStyle: "thin",
              leftBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            });
          }
        }
        data.push(newRow);
      });
    }

    data.push([
      {},
      {
        value: "Totals",
        fontSize: 12,
        leftBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(totals.loads).toLocaleString("en-US"),
        fontSize: 12,
        bottomBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(totals.weight_tons).toLocaleString("en-US", {
          maximumFractionDigits: 2,
        }),
        fontSize: 12,
        bottomBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
      },
      {
        value: "",
        fontSize: 12,
        bottomBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(totals.freight_rev).toLocaleString("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }),
        fontSize: 12,
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
      },
    ]);

    const projectHeader = [
      {},
      {
        value: "Job",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        leftBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Total Tier Loads",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Total Tier Tons",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Tier Cost ($)",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
    ];

    data.push(blankRow, projectHeader);
    projectIds.forEach((id) => {
      data.push([
        {},
        {
          value: projectTotals[id].project_name,
          fontSize: 12,
          leftBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: parseFloat(projectTotals[id].loads).toLocaleString("en-US"),
          fontSize: 12,
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: parseFloat(projectTotals[id].weight).toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          }),
          fontSize: 12,
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: parseFloat(projectTotals[id].cost).toLocaleString("en-US", {
            maximumFractionDigits: 2,
            minimumFractionDigits: 2,
          }),
          fontSize: 12,
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          align: "center",
        },
      ]);
    });
    data.push([
      {},
      {
        value: "Totals",
        fontSize: 12,
        leftBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(projectTotals[0].loads).toLocaleString("en-US"),
        fontSize: 12,
        bottomBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(projectTotals[0].weight).toLocaleString("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }),
        fontSize: 12,
        bottomBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(projectTotals[0].cost).toLocaleString("en-US", {
          maximumFractionDigits: 2,
          minimumFractionDigits: 2,
        }),
        fontSize: 12,
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
      },
    ]);

    data.push([{}], [{}], [{}], [{}]);
    data.push(loadsHeader);

    loadsData.forEach((l) => {
      data.push(l);
    });

    let loadTotals;

    loadTotals = [
      {
        value: "Totals",
        fontSize: 12,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: totals.loads,
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {},
      {},
      {},
      {},
      {},
      {},
      {},
      {
        value: parseFloat(totals.weight_tons.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(totals.project_inv_rev.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(totals.freight_rev.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(totals.total_rev.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
    ];

    data.push(loadTotals);
    await writeXlsxFile(data, {
      columns,
      fileName,
    });
  }
};

export const GenerateVendorInvoiceDownload = async (
  invoice,
  invoiceLoads,
  uninvoicedLoads,
  uninvoicedTotal,
  jobName,
  vendorName,
  projects,
  adjustments,
  methodId,
) => {
  if (invoice && invoiceLoads && (jobName || vendorName)) {
    // replace periods from job name and invoice name

    var fileName;
    const invName = invoice.invoice_name.replace(/\./g, "-");
    if (jobName) {
      const newJobName = jobName.replace(/\./g, "-");
      fileName = `${newJobName} - ${invName}`;
    } else {
      const newVendorName = vendorName.replace(/\./g, "-");
      fileName = `${newVendorName} - ${invName}`;
    }
    var adjustmentTotal = 0;
    if (adjustments.invoice_adjustment) {
      adjustmentTotal = parseFloat(
        adjustments.invoice_adjustment.total_adjustment,
      );
    }

    const columns = [
      { width: 15 },
      { width: 20 },
      { width: 30 },
      { width: 25 },
      { width: 25 },
      { width: 40 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
    ];
    const blankRow = [{}];
    const totalsRows = [
      {},
      {
        value: invoice.total_loads,
        fontSize: 12,
        leftBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
        bottomBorderStyle: "thin",
      },
    ];

    const totalsHeader = [
      {},
      {
        value: "Loads",
        fontWeight: "bold",
        fontSize: 15,
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
    ];

    if (!invoice.is_asset) {
      totalsHeader.push({
        value: "Hauling Tons",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      });
      totalsRows.push({
        value: parseFloat(invoice.total_weight_tons.toFixed(2)),
        fontSize: 12,
        align: "center",
        bottomBorderStyle: "thin",
      });
    }

    totalsHeader.push({
      value: "Total Freight $",
      fontWeight: "bold",
      fontSize: 15,
      topBorderStyle: "thin",
      bottomBorderStyle: "thin",
      align: "center",
    });
    totalsRows.push({
      value: parseFloat(invoice.freight_cost.toFixed(2)),
      fontSize: 12,
      align: "center",
      bottomBorderStyle: "thin",
    });

    const endTotHeader = [
      {
        value: "Total FSC $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Gross $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Adjustments $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Net $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Not Invoiced Total $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
    ];
    totalsHeader.push(...endTotHeader);
    const data = [blankRow, totalsHeader];

    const endToTotalsRows = [
      {
        value: parseFloat(invoice.fsc_cost.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
      },
      {
        value: parseFloat((invoice.freight_cost + invoice.fsc_cost).toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: parseFloat(adjustmentTotal.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: parseFloat(
          (invoice.freight_cost + invoice.fsc_cost + adjustmentTotal).toFixed(
            2,
          ),
        ),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: parseFloat(uninvoicedTotal.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
    ];
    totalsRows.push(...endToTotalsRows);
    data.push(totalsRows);
    const mileageHeader = [
      {},
      {
        value: "Mileage",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        leftBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Weight (tons)",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Freight Rate $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Freight $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "FSC Rate $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "FSC $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Total $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
    ];

    const freightHeader = [
      {
        value: "Terminal",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Product",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "PO Number",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Ticket No",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];

    const endHeaders = [
      {
        value: "Approved Mileage",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Net Weight (tons)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Freight ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Fuel Surcharge ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Gross ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];

    // loads

    var loadsHeader;
    var newLoads = [];
    var mileageBands = {};
    if (!projects) {
      loadsHeader = [
        {},
        {
          value: "Load No",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Delivery Date",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Carrier",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Driver",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
      ];
      if (!invoice.is_asset) {
        loadsHeader.push(...freightHeader);
      }
      loadsHeader.push(...endHeaders);
    } else {
      loadsHeader = [
        {},
        {
          value: "Load No",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Job Name",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Delivery Date",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Carrier",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Driver",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
      ];
      if (!invoice.is_asset) {
        loadsHeader.push(...freightHeader);
      }
      loadsHeader.push(...endHeaders);
    }
    invoiceLoads.forEach((load) => {
      let freightLoads = [
        {
          value: load.terminal_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.product_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.po_number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.ticket_number,
          fontSize: 12,
          align: "center",
        },
      ];

      let endLoads = [
        {
          value: load.mileage,
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.weight_tons.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
        {
          value: parseFloat(load.freight_cost.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
        {
          value: parseFloat(load.fsc_cost.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
        {
          value: parseFloat(load.total_cost.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
      ];
      let delivered = DeliveredOn(load.delivered_date);
      let newLoad;
      if (!projects) {
        newLoad = [
          {},
          {
            value: load.load_no,
            fontSize: 12,
            align: "center",
          },
          {
            value: delivered,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.carrier_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.driver_name,
            fontSize: 12,
            align: "center",
          },
        ];
        if (!invoice.is_asset) {
          newLoad.push(...freightLoads);
        }
        newLoad.push(...endLoads);
      } else {
        newLoad = [
          {},
          {
            value: load.load_no,
            fontSize: 12,
            align: "center",
          },
          {
            value: projects.filter((x) => x.id === load.project_id)[0].job_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: delivered,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.carrier_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.driver_name,
            fontSize: 12,
            align: "center",
          },
        ];
        if (!invoice.is_asset) {
          newLoad.push(...freightLoads);
        }
        newLoad.push(...endLoads);
      }

      newLoads.push([...newLoad]);
      if (!mileageBands[load.mileage]) {
        mileageBands[load.mileage] = [
          {
            weight: load.weight_tons,
            freight_per_ton: 0,
            freight: load.freight_cost,
            fsc_per_ton: 0,
            unique_freight_rate: getRateFromMethod(
              7,
              load.weight_tons,
              load.mileage,
              load.freight_cost,
              load.freight_rev,
            ).toFixed(2),
            unique_fsc_rate: getRateFromMethod(
              methodId,
              load.weight_tons,
              load.mileage,
              load.fsc_cost,
            ).toFixed(2),
            fsc: load.fsc_cost,
            total: load.freight_cost + load.fsc_cost,
          },
        ];
      } else {
        var m = mileageBands[load.mileage].filter(
          (x) =>
            getRateFromMethod(
              7,
              load.weight_tons,
              load.mileage,
              load.freight_cost,
            ).toFixed(2) === x.unique_freight_rate &&
            getRateFromMethod(
              methodId,
              load.weight_tons,
              load.mileage,
              load.fsc_cost,
            ).toFixed(2) === x.unique_fsc_rate,
        );
        if (m.length > 0) {
          m[0].weight = m[0].weight + load.weight_tons;
          m[0].freight = m[0].freight + load.freight_cost;
          m[0].fsc = m[0].fsc + load.fsc_cost;
          m[0].total = m[0].total + load.freight_cost + load.fsc_cost;
        } else {
          mileageBands[load.mileage].push({
            weight: load.weight_tons,
            freight_per_ton: 0,
            freight: load.freight_cost,
            fsc_per_ton: 0,
            unique_freight_rate: getRateFromMethod(
              7,
              load.weight_tons,
              load.mileage,
              load.freight_cost,
            ).toFixed(2),
            unique_fsc_rate: getRateFromMethod(
              methodId,
              load.weight_tons,
              load.mileage,
              load.fsc_cost,
            ).toFixed(2),
            fsc: load.fsc_cost,
            total: load.freight_cost + load.fsc_cost,
          });
        }
      }
    });

    data.push(blankRow, blankRow);
    data.push([
      {},
      {
        value: "Mileages",
        fontSize: 20,
        align: "center",
        span: 7,
      },
    ]);
    data.push(mileageHeader);
    for (const [key, value] of Object.entries(mileageBands)) {
      var keys = [];
      var i = 0;
      for (const [, v] of Object.entries(value)) {
        if (v.weight > 0) {
          v.freight_per_ton = parseFloat(v.unique_freight_rate);
          v.fsc_per_ton = parseFloat(v.unique_fsc_rate);
        }
        keys.push(key);
        var mileageBand = [];
        if (i === 0) {
          mileageBand.push(
            {},
            {
              value: key,
              fontSize: 15,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              leftBorderStyle: "thin",
              align: "center",
            },
          );
        } else if (keys[i - 1] !== keys[i]) {
          mileageBand.push(
            {},
            {
              value: key,
              fontSize: 15,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              leftBorderStyle: "thin",
              align: "center",
            },
          );
        } else {
          mileageBand.push(
            {},
            {
              value: "",
              fontSize: 15,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              leftBorderStyle: "thin",
              align: "center",
            },
          );
        }
        mileageBand.push(
          {
            value: v.weight,
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(v.freight_per_ton.toFixed(2)),
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(v.freight.toFixed(2)),
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(v.fsc_per_ton.toFixed(2)),
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(v.fsc.toFixed(2)),
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(v.total.toFixed(2)),
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
        );
        data.push(mileageBand);
        i += 1;
      }
    }

    data.push(blankRow, blankRow);

    if (adjustments && adjustments.adjustment_fields) {
      data.push(blankRow, blankRow);
      data.push([
        {},
        {
          value: "Adjustments",
          fontWeight: "bold",
          fontSize: 20,
          align: "center",
          span: 5,
        },
      ]);
      data.push([
        {},
        {
          value: "Item",
          fontWeight: "bold",
          fontSize: 15,
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Type",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Amount $",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Date",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Comments",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          align: "center",
        },
      ]);
      adjustments.adjustment_fields.forEach((f) => {
        let adjDate = getDateWithoutTimestamp(f.date_of_adjustment);
        data.push([
          {},
          {
            value: f.field_name,
            fontSize: 12,
            leftBorderStyle: "thin",
            align: "center",
            fontWeight: "bold",
            bottomBorderStyle: "thin",
          },
          {
            value: f.is_credit ? "Credit" : "Charge",
            fontSize: 12,
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: parseFloat(f.field_value),
            fontSize: 12,
            type: Number,
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: adjDate,
            fontSize: 12,
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: f.adjustment_comments,
            fontSize: 12,
            align: "center",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          },
        ]);
      });
      data.push([
        {},
        {
          value: "Total",
          fontSize: 15,
          leftBorderStyle: "thin",
          align: "center",
          fontWeight: "bold",
          bottomBorderStyle: "thin",
        },
        { bottomBorderStyle: "thin" },
        {
          value: parseFloat(adjustments.invoice_adjustment.total_adjustment),
          fontSize: 15,
          fontWeight: "bold",
          type: Number,
          align: "center",
          bottomBorderStyle: "thin",
        },
        {
          bottomBorderStyle: "thin",
        },
        {
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
      ]);
    }

    var uninvoicedHeader;
    if (uninvoicedLoads) {
      if (!projects) {
        data.push([
          {},
          {
            value: "Loads Not Invoiced",
            fontWeight: "bold",
            fontSize: 20,
            align: "center",
            span: 13,
          },
        ]);
        uninvoicedHeader = [
          {},
          {
            value: "Load No",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Duplicate Tickets Load #s",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Ticket Is Missing",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Locked Reason",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Approval Status",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Delivery Date",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Carrier",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Driver",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
        ];
        if (!invoice.is_asset) {
          uninvoicedHeader.push(...freightHeader);
        }
        uninvoicedHeader.push(...endHeaders);
      } else {
        data.push([
          {},
          {
            value: "Loads Not Invoiced",
            fontWeight: "bold",
            fontSize: 20,
            align: "center",
            span: 14,
          },
        ]);
        uninvoicedHeader = [
          {},
          {
            value: "Load No",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Job Name",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Duplicate Tickets Load #s",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Ticket Is Missing",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Locked Reason",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Approval Status",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Delivery Date",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Carrier",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Driver",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
        ];
        if (!invoice.is_asset) {
          uninvoicedHeader.push(...freightHeader);
        }
        uninvoicedHeader.push(...endHeaders);
      }
      data.push(uninvoicedHeader);

      uninvoicedLoads.forEach((load) => {
        let freightLoads = [
          {
            value: load.terminal_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.product_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.po_number,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.ticket_number,
            fontSize: 12,
            align: "center",
          },
        ];

        let endLoads = [
          {
            value: load.mileage,
            fontSize: 12,
            align: "center",
          },
          {
            value: parseFloat(load.weight_tons.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.freight_cost.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.fsc_cost.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.total_cost.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
        ];
        let delivered = DeliveredOn(load.delivered_date);
        let newLoad;
        if (!projects) {
          newLoad = [
            {},
            {
              value: load.load_no,
              fontSize: 12,
              align: "center",
            },
            {
              value:
                load.duplicate_tickets.length > 1
                  ? [...load.duplicate_tickets.slice(1)]
                  : "",
              fontSize: 12,
              align: "center",
            },
            {
              value: load.ticket_is_missing ? "Yes" : "",
              fontSize: 12,
              align: "center",
            },
            {
              value: load.locked_reason,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.propconnect_approval_status,
              fontSize: 12,
              align: "center",
            },
            {
              value: delivered,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.carrier_name,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.driver_name,
              fontSize: 12,
              align: "center",
            },
          ];
          if (!invoice.is_asset) {
            newLoad.push(...freightLoads);
          }
          newLoad.push(...endLoads);
        } else {
          newLoad = [
            {},
            {
              value: load.load_no,
              fontSize: 12,
              align: "center",
            },
            {
              value: projects.filter((x) => x.id === load.project_id)[0]
                .job_name,
              fontSize: 12,
              align: "center",
            },
            {
              value:
                load.duplicate_tickets.length > 1
                  ? [...load.duplicate_tickets.slice(1)]
                  : "",
              fontSize: 12,
              align: "center",
            },
            {
              value: load.ticket_is_missing ? "Yes" : "",
              fontSize: 12,
              align: "center",
            },
            {
              value: load.locked_reason,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.propconnect_approval_status,
              fontSize: 12,
              align: "center",
            },
            {
              value: delivered,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.carrier_name,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.driver_name,
              fontSize: 12,
              align: "center",
            },
          ];
          if (!invoice.is_asset) {
            newLoad.push(...freightLoads);
          }
          newLoad.push(...endLoads);
        }
        data.push(newLoad);
      });
    }

    data.push(blankRow, blankRow);
    if (!projects) {
      data.push([
        {},
        {
          value: "Invoiced Loads",
          fontWeight: "bold",
          fontSize: 20,
          align: "center",
          span: 13,
        },
      ]);
    } else {
      data.push([
        {},
        {
          value: "Invoiced Loads",
          fontWeight: "bold",
          fontSize: 20,
          align: "center",
          span: 14,
        },
      ]);
    }
    data.push(loadsHeader);
    data.push(...newLoads);

    let freightGap = [{}, {}, {}, {}];

    let endTotal = [
      {},
      {},
      {},
      {},
      {
        value: parseFloat(invoice.total_weight_tons.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(invoice.freight_cost.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(invoice.fsc_cost.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat((invoice.freight_cost + invoice.fsc_cost).toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
    ];
    let loadTotals;
    if (!projects) {
      loadTotals = [
        {
          value: "Totals",
          fontSize: 12,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: invoice.total_loads,
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
      ];
      if (!invoice.is_asset) {
        loadTotals.push(...freightGap);
      }
      loadTotals.push(...endTotal);
    } else {
      loadTotals = [
        {
          value: "Totals",
          fontSize: 12,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: invoice.total_loads,
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
        {},
      ];
      if (!invoice.is_asset) {
        loadTotals.push(...freightGap);
      }
      loadTotals.push(...endTotal);
    }

    data.push(loadTotals);
    await writeXlsxFile(data, {
      columns,
      fileName,
    });
  }
};

export const GenerateBackup = async (
  invoice,
  invoiceLoads,
  uninvoicedLoads,
  uninvoicedTotal,
  jobName,
  vendorName,
  projects,
  adjustments,
  methodId,
  relationType,
  projectSandRates,
) => {
  if (invoice && invoiceLoads) {
    // replace periods from job name and invoice name

    var fileName;
    const invName = invoice.invoice_name.replace(/\./g, "-");
    if (jobName) {
      const newJobName = jobName.replace(/\./g, "-");
      fileName = `${newJobName} - ${invName}`;
    } else if (!jobName && vendorName) {
      const newVendorName = vendorName.replace(/\./g, "-");
      fileName = `${newVendorName} - ${invName}`;
    } else {
      fileName = invName;
    }
    var adjustmentTotal = 0;
    if (adjustments.invoice_adjustment) {
      adjustmentTotal = parseFloat(
        adjustments.invoice_adjustment.total_adjustment,
      );
    }
    const isCustomer = relationType === "customer";
    const sandExists = invoice.sand_rev > 0 && relationType === "customer";
    const sandPOs = {};

    const columns = [
      { width: 15 },
      { width: 30 },
      { width: 30 },
      { width: 25 },
      { width: 25 },
      { width: 40 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
      { width: 30 },
    ];
    const blankRow = [{}];
    const totalsRows = [
      {},
      {
        value: invoice.total_loads,
        fontSize: 12,
        leftBorderStyle: "thin",
        align: "center",
        fontWeight: "bold",
        bottomBorderStyle: "thin",
      },
    ];

    const totalsHeader = [
      {},
      {
        value: "Loads",
        fontWeight: "bold",
        fontSize: 15,
        leftBorderStyle: "thin",
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      },
    ];

    if (!invoice.is_asset) {
      totalsHeader.push({
        value: "Hauling Tons",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        align: "center",
      });
      totalsRows.push({
        value: parseFloat(invoice.total_weight_tons.toFixed(2)),
        fontSize: 12,
        align: "center",
        bottomBorderStyle: "thin",
      });
    }

    totalsHeader.push({
      value: "Total Freight $",
      fontWeight: "bold",
      fontSize: 15,
      topBorderStyle: "thin",
      bottomBorderStyle: "thin",
      align: "center",
    });
    totalsRows.push({
      value: parseFloat(invoice.freight_cost.toFixed(2)),
      fontSize: 12,
      align: "center",
      bottomBorderStyle: "thin",
    });

    const endTotHeader = [
      {
        value: "Total FSC $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Gross $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Adjustments $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Net $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
    ];
    if (relationType !== "customer") {
      endTotHeader.push({
        value: "Not Invoiced Total $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      });
    }
    totalsHeader.push(...endTotHeader);
    const data = [blankRow, totalsHeader];

    const endToTotalsRows = [
      {
        value: parseFloat(invoice.fsc_cost.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
      },
      {
        value: parseFloat((invoice.freight_cost + invoice.fsc_cost).toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: parseFloat(adjustmentTotal.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
      {
        value: parseFloat(
          (invoice.freight_cost + invoice.fsc_cost + adjustmentTotal).toFixed(
            2,
          ),
        ),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      },
    ];
    if (relationType !== "customer") {
      endToTotalsRows.push({
        value: parseFloat(uninvoicedTotal.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
      });
    }
    totalsRows.push(...endToTotalsRows);
    data.push(totalsRows);
    const freightBandsHeader = [
      {},
      {
        value: "Mileage Band",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        leftBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Loads",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        leftBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Weight (tons)",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Rate $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Total $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        align: "center",
      },
    ];

    const fscBandsHeader = [
      {},
      {
        value: "Mileage Band",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        leftBorderStyle: "thin",
        align: "center",
      },
    ];
    if (methodId === 40) {
      fscBandsHeader.push({
        value: "Approved Miles",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        leftBorderStyle: "thin",
        align: "center",
      });
    }
    fscBandsHeader.push(
      {
        value: "Loads",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        leftBorderStyle: "thin",
        align: "center",
      },
      {
        value: methodId === 40 ? "Loaded Miles" : "Weight (tons)",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        leftBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Rate $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        leftBorderStyle: "thin",
        align: "center",
      },
      {
        value: "Total $",
        fontWeight: "bold",
        fontSize: 15,
        topBorderStyle: "thin",
        bottomBorderStyle: "thin",
        rightBorderStyle: "thin",
        leftBorderStyle: "thin",
        align: "center",
      },
    );

    const freightHeader = [
      {
        value: "Terminal",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Product",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "PO Number",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Ticket No",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];

    const endHeaders = [
      {
        value: "Approved Mileage",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Net Weight (tons)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Freight ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
      {
        value: "Fuel Surcharge ($)",
        fontWeight: "bold",
        fontSize: 14,
        align: "center",
      },
    ];

    if (sandExists) {
      endHeaders.push(
        {
          value: "Gross Sand Weight (tons)",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Moisture Weight (tons)",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Net Sand Weight (tons)",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Sand Cost ($)",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
      );
    }
    endHeaders.push({
      value: "Gross ($)",
      fontWeight: "bold",
      fontSize: 14,
      align: "center",
    });

    // loads

    var loadsHeader;
    var newLoads = [];
    var freightBands = {};
    var fscBands = {};
    if (!projects) {
      loadsHeader = [
        {},
        {
          value: "Load No",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Delivery Date",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Carrier",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Driver",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
      ];
      if (!invoice.is_asset) {
        loadsHeader.push(...freightHeader);
      }
      loadsHeader.push(...endHeaders);
    } else {
      loadsHeader = [
        {},
        {
          value: "Load No",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Job Name",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Delivery Date",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Carrier",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
        {
          value: "Driver",
          fontWeight: "bold",
          fontSize: 14,
          align: "center",
        },
      ];
      if (!invoice.is_asset) {
        loadsHeader.push(...freightHeader);
      }
      loadsHeader.push(...endHeaders);
    }
    invoiceLoads.forEach((load) => {
      let freightLoads = [
        {
          value: load.terminal_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.product_name,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.po_number,
          fontSize: 12,
          align: "center",
        },
        {
          value: load.ticket_number,
          fontSize: 12,
          align: "center",
        },
      ];

      let endLoads = [
        {
          value: load.mileage,
          fontSize: 12,
          align: "center",
        },
        {
          value: parseFloat(load.weight_tons.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
        {
          value: !isCustomer
            ? parseFloat(load.freight_cost.toFixed(2))
            : parseFloat(load.freight_rev.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
        {
          value: !isCustomer
            ? parseFloat(load.fsc_cost.toFixed(2))
            : parseFloat(load.fsc_rev.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        },
      ];
      let sandLoads = [];
      var sRate;
      if (sandExists) {
        let isSand = load.sand_rev > 0;
        if (isSand) {
          sRate = projectSandRates.filter(
            (x) => x.po_number === load.po_number,
          );
        }
        sandLoads.push(
          {
            value: isSand ? parseFloat(load.weight_tons.toFixed(2)) : 0,
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: isSand
              ? parseFloat(
                  (
                    (load.weight_tons * sRate[0].moistuire_content_rev) /
                    100
                  ).toFixed(2),
                )
              : 0,
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: isSand
              ? parseFloat(
                  (
                    load.weight_tons *
                    (1 - sRate[0].moistuire_content_rev / 100)
                  ).toFixed(2),
                )
              : 0,
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.sand_rev.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
        );
      }

      let delivered = DeliveredOn(load.delivered_date);
      let newLoad;
      if (!projects) {
        newLoad = [
          {},
          {
            value: load.load_no,
            fontSize: 12,
            align: "center",
          },
          {
            value: delivered,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.carrier_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.driver_name,
            fontSize: 12,
            align: "center",
          },
        ];
        if (!invoice.is_asset) {
          newLoad.push(...freightLoads);
        }
        newLoad.push(...endLoads);
        
        if (sandExists) {
          newLoad.push(...sandLoads)
        }

        newLoad.push({
          value: !isCustomer
            ? parseFloat(load.total_cost.toFixed(2))
            : parseFloat(load.total_rev.toFixed(2)),
          fontSize: 12,
          type: Number,
          align: "center",
        });
      } else {
        newLoad = [
          {},
          {
            value: load.load_no,
            fontSize: 12,
            align: "center",
          },
          {
            value: projects.filter((x) => x.id === load.project_id)[0].job_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: delivered,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.carrier_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.driver_name,
            fontSize: 12,
            align: "center",
          },
        ];
        if (!invoice.is_asset) {
          newLoad.push(...freightLoads);
        }
        newLoad.push(...endLoads);
      }

      newLoads.push([...newLoad]);
      var loadMileageBand = getMileageBand(load.mileage);
      if (!freightBands[loadMileageBand]) {
        freightBands[loadMileageBand] = [
          {
            weight: load.weight_tons,
            loads: 1,
            freight_per_ton: 0,
            freight: load.freight_cost,
            unique_freight_rate: getRateFromMethod(
              7,
              load.weight_tons,
              load.mileage,
              load.freight_cost,
              load.freight_rev,
              isCustomer,
            ).toFixed(2),
          },
        ];
      } else {
        let m = freightBands[loadMileageBand].filter(
          (x) =>
            getRateFromMethod(
              7,
              load.weight_tons,
              load.mileage,
              load.freight_cost,
              load.freight_rev,
              isCustomer,
            ).toFixed(2) === x.unique_freight_rate,
        );
        if (m.length > 0) {
          m[0].weight = m[0].weight + load.weight_tons;
          m[0].freight = m[0].freight + load.freight_cost;
          m[0].loads = m[0].loads + 1;
        } else {
          freightBands[loadMileageBand].push({
            weight: load.weight_tons,
            loads: 1,
            freight_per_ton: 0,
            freight: load.freight_cost,
            unique_freight_rate: getRateFromMethod(
              7,
              load.weight_tons,
              load.mileage,
              load.freight_cost,
              load.freight_rev,
              isCustomer,
            ).toFixed(2),
          });
        }
      }
      if (load.fsc_cost > 0) {
        if (!fscBands[loadMileageBand]) {
          fscBands[loadMileageBand] = [
            {
              weight: load.weight_tons,
              fsc_rate: 0,
              loads: 1,
              loadedMiles: load.mileage,
              mileage: load.mileage,
              fsc: load.fsc_cost,
              unique_fsc_rate: getRateFromMethod(
                methodId,
                load.weight_tons,
                load.mileage,
                load.fsc_cost,
                load.fsc_rev,
                isCustomer,
              ).toFixed(2),
            },
          ];
        } else {
          let m = fscBands[loadMileageBand].filter(
            (x) =>
              getRateFromMethod(
                methodId,
                load.weight_tons,
                load.mileage,
                load.fsc_cost,
                load.fsc_rev,
                isCustomer,
              ).toFixed(2) === x.unique_fsc_rate,
          );
          if (m.length > 0) {
            m[0].weight = m[0].weight + load.weight_tons;
            m[0].fsc = m[0].fsc + load.fsc_cost;
            m[0].loads = m[0].loads + 1;
            m[0].loadedMiles = m[0].loadedMiles + load.mileage;
          } else {
            fscBands[loadMileageBand].push({
              weight: load.weight_tons,
              fsc_rate: 0,
              loads: 1,
              mileage: load.mileage,
              loadedMiles: load.mileage,
              fsc: load.fsc_cost,
              unique_fsc_rate: getRateFromMethod(
                methodId,
                load.weight_tons,
                load.mileage,
                load.fsc_cost,
                load.fsc_rev,
                isCustomer,
              ).toFixed(2),
            });
          }
        }
      }
      if (sandExists && load.sand_rev > 0) {
        if (sRate.length > 0) {
          if (!sandPOs[load.terminal_name]) {
            sandPOs[load.terminal_name] = [
              {
                po_number: load.po_number,
                sand_type: load.product_name,
                loads: 1,
                rate: sRate[0].rev_rate,
                gross_weight: load.weight_tons,
                moisture_weight:
                  (load.weight_tons * sRate[0].moistuire_content_rev) / 100,
                net_weight:
                  load.weight_tons * (1 - sRate[0].moistuire_content_rev / 100),
                sand_rev: load.sand_rev,
              },
            ];
          } else {
            let m = sandPOs[load.terminal_name].filter(
              (x) => x.po_number === load.po_number,
            );
            if (m.length > 0) {
              m[0].gross_weight = m[0].gross_weight + load.weight_tons;
              m[0].loads = m[0].loads + 1;
              m[0].moisture_weight =
                m[0].moisture_weight +
                (load.weight_tons * sRate[0].moistuire_content_rev) / 100;
              m[0].net_weight =
                m[0].net_weight +
                load.weight_tons * (1 - sRate[0].moistuire_content_rev / 100);
              m[0].sand_rev = m[0].sand_rev + load.sand_rev;
            } else {
              sandPOs[load.terminal_name].push({
                po_number: load.po_number,
                sand_type: load.product_name,
                loads: 1,
                rate: sRate[0].rev_rate,
                gross_weight: load.weight_tons,
                moisture_weight:
                  (load.weight_tons * sRate[0].moistuire_content_rev) / 100,
                net_weight:
                  load.weight_tons * (1 - sRate[0].moistuire_content_rev / 100),
                sand_rev: load.sand_rev,
              });
            }
          }
        }
      }
    });
    data.push(blankRow, blankRow);
    data.push([
      {},
      {
        value: "Freight Summary",
        fontSize: 20,
        align: "center",
        span: 5,
      },
    ]);
    data.push(freightBandsHeader);
    for (const [key, value] of Object.entries(freightBands)) {
      let keys = [];
      let i = 0;
      let keyTots = {
        loads: 0,
        weight: 0,
        total: 0,
      };
      for (const [, v] of Object.entries(value)) {
        if (v.weight > 0) {
          v.freight_per_ton = parseFloat(v.unique_freight_rate);
        }
        keyTots.loads = keyTots.loads + v.loads;
        keyTots.weight = keyTots.weight + v.weight;
        keyTots.total = keyTots.total + v.freight;
        keys.push(key);
        let mileageBand = [];
        if (i === 0) {
          mileageBand.push(
            {},
            {
              value: key,
              fontSize: 15,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              leftBorderStyle: "thin",
              align: "center",
            },
          );
        } else if (keys[i - 1] !== keys[i]) {
          mileageBand.push(
            {},
            {
              value: key,
              fontSize: 15,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              leftBorderStyle: "thin",
              align: "center",
            },
          );
        } else {
          mileageBand.push(
            {},
            {
              value: "",
              fontSize: 15,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              leftBorderStyle: "thin",
              align: "center",
            },
          );
        }
        mileageBand.push(
          {
            value: v.loads,
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(v.weight.toFixed(2)),
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(v.freight_per_ton.toFixed(2)),
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(v.freight.toFixed(2)),
            fontSize: 15,
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
        );
        data.push(mileageBand);
        i += 1;
      }
      data.push([
        {},
        {
          value: "",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          leftBorderStyle: "thin",
          align: "center",
        },
        {
          value: keyTots.loads,
          fontWeight: "bold",
          type: Number,
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          leftBorderStyle: "thin",
          align: "center",
        },
        {
          value: parseFloat(keyTots.weight.toFixed(2)),
          fontWeight: "bold",
          type: Number,
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          leftBorderStyle: "thin",
          align: "center",
        },
        {
          value: "",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          leftBorderStyle: "thin",
          align: "center",
        },
        {
          value: parseFloat(keyTots.total.toFixed(2)),
          fontWeight: "bold",
          type: Number,
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          leftBorderStyle: "thin",
          align: "center",
        },
      ]);
    }

    if (invoice.fsc_cost > 0) {
      data.push(blankRow, blankRow);
      data.push([
        {},
        {
          value: "FSC Summary",
          fontSize: 20,
          align: "center",
          span: methodId === 40 ? 6 : 5,
        },
      ]);
      data.push(fscBandsHeader);
      for (const [key, value] of Object.entries(fscBands)) {
        let keys = [];
        let i = 0;
        let keyTots = {
          loads: 0,
          weight: 0,
          loadedMiles: 0,
          total: 0,
        };
        for (const [, v] of Object.entries(value)) {
          if (v.weight > 0) {
            v.fsc_rate = parseFloat(v.unique_fsc_rate);
          }
          keyTots.loads = keyTots.loads + v.loads;
          keyTots.weight = keyTots.weight + v.weight;
          keyTots.loadedMiles = keyTots.loadedMiles + v.loadedMiles;
          keyTots.total = keyTots.total + v.fsc;
          keys.push(key);
          let mileageBand = [];
          if (i === 0) {
            mileageBand.push(
              {},
              {
                value: key,
                fontSize: 15,
                topBorderStyle: "thin",
                bottomBorderStyle: "thin",
                rightBorderStyle: "thin",
                leftBorderStyle: "thin",
                align: "center",
              },
            );
          } else if (keys[i - 1] !== keys[i]) {
            mileageBand.push(
              {},
              {
                value: key,
                fontSize: 15,
                topBorderStyle: "thin",
                bottomBorderStyle: "thin",
                rightBorderStyle: "thin",
                leftBorderStyle: "thin",
                align: "center",
              },
            );
          } else {
            mileageBand.push(
              {},
              {
                value: "",
                fontSize: 15,
                topBorderStyle: "thin",
                bottomBorderStyle: "thin",
                rightBorderStyle: "thin",
                leftBorderStyle: "thin",
                align: "center",
              },
            );
          }

          if (methodId === 40) {
            mileageBand.push({
              value: v.mileage,
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            });
          }

          mileageBand.push(
            {
              value: v.loads,
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
            {
              value:
                methodId === 40
                  ? v.loadedMiles
                  : parseFloat(v.weight.toFixed(2)),
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
            {
              value: parseFloat(v.fsc_rate.toFixed(2)),
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
            {
              value: parseFloat(v.fsc.toFixed(2)),
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
          );
          data.push(mileageBand);
          i += 1;
        }
        let totsRow = [
          {},
          {
            value: "",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            leftBorderStyle: "thin",
            align: "center",
          },
        ];

        if (methodId === 40) {
          totsRow.push({
            value: "",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            leftBorderStyle: "thin",
            align: "center",
          });
        }
        totsRow.push(
          {
            value: keyTots.loads,
            fontWeight: "bold",
            type: Number,
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            leftBorderStyle: "thin",
            align: "center",
          },
          {
            value:
              methodId === 40
                ? keyTots.loadedMiles
                : parseFloat(keyTots.weight.toFixed(2)),
            fontWeight: "bold",
            type: Number,
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            leftBorderStyle: "thin",
            align: "center",
          },
          {
            value: "",
            fontWeight: "bold",
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            leftBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(keyTots.total.toFixed(2)),
            fontWeight: "bold",
            type: Number,
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            leftBorderStyle: "thin",
            align: "center",
          },
        );
        data.push(totsRow);
      }
    }
    if (sandExists) {
      data.push(blankRow, blankRow);
      data.push([
        {},
        {
          value: "Sand Totals",
          fontWeight: "bold",
          fontSize: 20,
          align: "center",
          span: 9,
        },
      ]);
      data.push([
        {},
        {
          value: "Terminal",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          rightBorderStyle: "thin",
          bottomBorderStyle: "thin",
          leftBorderStyle: "thin",
          align: "center",
        },
        {
          value: "PO",
          fontWeight: "bold",
          fontSize: 15,
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Sand Type",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          rightBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Loads",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          rightBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Gross Weight",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          rightBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Moisture Weight",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          rightBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Net Weight",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          align: "center",
        },
        {
          value: "$/Ton",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Total $",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          align: "center",
        },
      ]);
      for (const [key, value] of Object.entries(sandPOs)) {
        let tots = {
          loads: 0,
          gross_weight: 0,
          moisture_weight: 0,
          net_weight: 0,
          sand_rev: 0,
        };
        value.forEach((po, i) => {
          tots.loads = tots.loads + po.loads;
          tots.gross_weight = tots.gross_weight + po.gross_weight;
          tots.moisture_weight = tots.moisture_weight + po.moisture_weight;
          tots.net_weight = tots.net_weight + po.net_weight;
          tots.sand_rev = tots.sand_rev + po.sand_rev;
          data.push([
            {},
            {
              value: i === 0 ? key : "",
              fontSize: 15,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              leftBorderStyle: "thin",
              align: "center",
            },
            {
              value: po.po_number,
              fontSize: 15,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              leftBorderStyle: "thin",
              align: "center",
            },
            {
              value: po.sand_type,
              fontSize: 15,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              leftBorderStyle: "thin",
              align: "center",
            },
            {
              value: po.loads,
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
            {
              value: parseFloat(po.gross_weight.toFixed(2)),
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
            {
              value: parseFloat(po.moisture_weight.toFixed(2)),
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
            {
              value: parseFloat(po.net_weight.toFixed(2)),
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
            {
              value: po.rate,
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
            {
              value: parseFloat(po.sand_rev.toFixed(2)),
              fontSize: 15,
              type: Number,
              topBorderStyle: "thin",
              bottomBorderStyle: "thin",
              rightBorderStyle: "thin",
              align: "center",
            },
          ]);
        });
        data.push([
          {},
          {
            value: `${key} Totals`,
            fontSize: 15,
            fontWeight: "bold",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            leftBorderStyle: "thin",
            align: "center",
          },
          {
            value: "",
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            leftBorderStyle: "thin",
            align: "center",
          },
          {
            value: "",
            fontSize: 15,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            leftBorderStyle: "thin",
            align: "center",
          },
          {
            value: tots.loads,
            fontSize: 15,
            type: Number,
            fontWeight: "bold",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(tots.gross_weight.toFixed(2)),
            fontSize: 15,
            type: Number,
            fontWeight: "bold",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(tots.moisture_weight.toFixed(2)),
            fontSize: 15,
            type: Number,
            fontWeight: "bold",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(tots.net_weight.toFixed(2)),
            fontSize: 15,
            type: Number,
            fontWeight: "bold",
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: "",
            fontSize: 15,
            fontWeight: "bold",
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
          {
            value: parseFloat(tots.sand_rev.toFixed(2)),
            fontSize: 15,
            fontWeight: "bold",
            type: Number,
            topBorderStyle: "thin",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
            align: "center",
          },
        ]);
      }
    }
    data.push(blankRow, blankRow);

    if (adjustments && adjustments.adjustment_fields) {
      data.push(blankRow, blankRow);
      data.push([
        {},
        {
          value: "Adjustments",
          fontWeight: "bold",
          fontSize: 20,
          align: "center",
          span: 5,
        },
      ]);
      data.push([
        {},
        {
          value: "Item",
          fontWeight: "bold",
          fontSize: 15,
          leftBorderStyle: "thin",
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Type",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Amount $",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Date",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          align: "center",
        },
        {
          value: "Comments",
          fontWeight: "bold",
          fontSize: 15,
          topBorderStyle: "thin",
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
          align: "center",
        },
      ]);
      adjustments.adjustment_fields.forEach((f) => {
        let adjDate = getDateWithoutTimestamp(f.date_of_adjustment);
        data.push([
          {},
          {
            value: f.field_name,
            fontSize: 12,
            leftBorderStyle: "thin",
            align: "center",
            fontWeight: "bold",
            bottomBorderStyle: "thin",
          },
          {
            value: f.is_credit ? "Credit" : "Charge",
            fontSize: 12,
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: parseFloat(f.field_value),
            fontSize: 12,
            type: Number,
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: adjDate,
            fontSize: 12,
            align: "center",
            bottomBorderStyle: "thin",
          },
          {
            value: f.adjustment_comments,
            fontSize: 12,
            align: "center",
            bottomBorderStyle: "thin",
            rightBorderStyle: "thin",
          },
        ]);
      });
      data.push([
        {},
        {
          value: "Total",
          fontSize: 15,
          leftBorderStyle: "thin",
          align: "center",
          fontWeight: "bold",
          bottomBorderStyle: "thin",
        },
        { bottomBorderStyle: "thin" },
        {
          value: parseFloat(adjustments.invoice_adjustment.total_adjustment),
          fontSize: 15,
          fontWeight: "bold",
          type: Number,
          align: "center",
          bottomBorderStyle: "thin",
        },
        {
          bottomBorderStyle: "thin",
        },
        {
          bottomBorderStyle: "thin",
          rightBorderStyle: "thin",
        },
      ]);
    }

    var uninvoicedHeader;
    if (uninvoicedLoads) {
      if (!projects) {
        data.push([
          {},
          {
            value: "Loads Not Invoiced",
            fontWeight: "bold",
            fontSize: 20,
            align: "center",
            span: 13,
          },
        ]);
        uninvoicedHeader = [
          {},
          {
            value: "Load No",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Duplicate Tickets Load #s",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Ticket Is Missing",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Locked Reason",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Approval Status",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Delivery Date",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Carrier",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Driver",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
        ];
        if (!invoice.is_asset) {
          uninvoicedHeader.push(...freightHeader);
        }
        uninvoicedHeader.push(...endHeaders);
      } else {
        data.push([
          {},
          {
            value: "Loads Not Invoiced",
            fontWeight: "bold",
            fontSize: 20,
            align: "center",
            span: 14,
          },
        ]);
        uninvoicedHeader = [
          {},
          {
            value: "Load No",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Job Name",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Duplicate Tickets Load #s",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Ticket Is Missing",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Locked Reason",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Approval Status",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Delivery Date",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Carrier",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
          {
            value: "Driver",
            fontWeight: "bold",
            fontSize: 14,
            align: "center",
          },
        ];
        if (!invoice.is_asset) {
          uninvoicedHeader.push(...freightHeader);
        }
        uninvoicedHeader.push(...endHeaders);
      }
      data.push(uninvoicedHeader);

      uninvoicedLoads.forEach((load) => {
        let freightLoads = [
          {
            value: load.terminal_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.product_name,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.po_number,
            fontSize: 12,
            align: "center",
          },
          {
            value: load.ticket_number,
            fontSize: 12,
            align: "center",
          },
        ];

        let endLoads = [
          {
            value: load.mileage,
            fontSize: 12,
            align: "center",
          },
          {
            value: parseFloat(load.weight_tons.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.freight_cost.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.fsc_cost.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
          {
            value: parseFloat(load.total_cost.toFixed(2)),
            fontSize: 12,
            type: Number,
            align: "center",
          },
        ];
        let delivered = DeliveredOn(load.delivered_date);
        let newLoad;
        if (!projects) {
          newLoad = [
            {},
            {
              value: load.load_no,
              fontSize: 12,
              align: "center",
            },
            {
              value:
                load.duplicate_tickets.length > 1
                  ? [...load.duplicate_tickets.slice(1)]
                  : "",
              fontSize: 12,
              align: "center",
            },
            {
              value: load.ticket_is_missing ? "Yes" : "",
              fontSize: 12,
              align: "center",
            },
            {
              value: load.locked_reason,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.propconnect_approval_status,
              fontSize: 12,
              align: "center",
            },
            {
              value: delivered,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.carrier_name,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.driver_name,
              fontSize: 12,
              align: "center",
            },
          ];
          if (!invoice.is_asset) {
            newLoad.push(...freightLoads);
          }
          newLoad.push(...endLoads);
        } else {
          newLoad = [
            {},
            {
              value: load.load_no,
              fontSize: 12,
              align: "center",
            },
            {
              value: projects.filter((x) => x.id === load.project_id)[0]
                .job_name,
              fontSize: 12,
              align: "center",
            },
            {
              value:
                load.duplicate_tickets.length > 1
                  ? [...load.duplicate_tickets.slice(1)]
                  : "",
              fontSize: 12,
              align: "center",
            },
            {
              value: load.ticket_is_missing ? "Yes" : "",
              fontSize: 12,
              align: "center",
            },
            {
              value: load.locked_reason,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.propconnect_approval_status,
              fontSize: 12,
              align: "center",
            },
            {
              value: delivered,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.carrier_name,
              fontSize: 12,
              align: "center",
            },
            {
              value: load.driver_name,
              fontSize: 12,
              align: "center",
            },
          ];
          if (!invoice.is_asset) {
            newLoad.push(...freightLoads);
          }
          newLoad.push(...endLoads);
        }
        data.push(newLoad);
      });
    }

    data.push(blankRow, blankRow);
    if (!projects) {
      data.push([
        {},
        {
          value: "Invoiced Loads",
          fontWeight: "bold",
          fontSize: 20,
          align: "center",
          span: 13,
        },
      ]);
    } else {
      data.push([
        {},
        {
          value: "Invoiced Loads",
          fontWeight: "bold",
          fontSize: 20,
          align: "center",
          span: 14,
        },
      ]);
    }
    data.push(loadsHeader);
    data.push(...newLoads);

    let freightGap = [{}, {}, {}, {}];

    let endTotal = [
      {},
      {},
      {},
      {},
      {
        value: parseFloat(invoice.total_weight_tons.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(invoice.freight_cost.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat(invoice.fsc_cost.toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
      {
        value: parseFloat((invoice.freight_cost + invoice.fsc_cost).toFixed(2)),
        fontSize: 12,
        type: Number,
        align: "center",
        fontWeight: "bold",
      },
    ];
    let loadTotals;
    if (!projects) {
      loadTotals = [
        {
          value: "Totals",
          fontSize: 12,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: invoice.total_loads,
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
      ];
      if (!invoice.is_asset) {
        loadTotals.push(...freightGap);
      }
      loadTotals.push(...endTotal);
    } else {
      loadTotals = [
        {
          value: "Totals",
          fontSize: 12,
          align: "center",
          fontWeight: "bold",
        },
        {
          value: invoice.total_loads,
          fontSize: 12,
          type: Number,
          align: "center",
          fontWeight: "bold",
        },
        {},
      ];
      if (!invoice.is_asset) {
        loadTotals.push(...freightGap);
      }
      loadTotals.push(...endTotal);
    }
    data.push(loadTotals);
    await writeXlsxFile(data, {
      columns,
      fileName,
    });
  }
};

// export const GenerateReceivedDownload = async (
//   invoice,
//   invoiceLoads,
//   adjustments,
//   uninvoicedLoads,
//   uninvoicedTotal,
//   methodId,
// ) => {
//   if (invoiceLoads && invoice) {
//     // replace periods from job name and invoice name
//     const fileName = invoice.invoice_name.replace(/\./g, "-");

//     var adjustmentTotal = 0;
//     if (adjustments.invoice_adjustment) {
//       adjustmentTotal = parseFloat(
//         adjustments.invoice_adjustment.total_adjustment,
//       );
//     }

//     const columns = [
//       { width: 15 },
//       { width: 20 },
//       { width: 30 },
//       { width: 25 },
//       { width: 25 },
//       { width: 40 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//       { width: 30 },
//     ];
//     const blankRow = [{}];
//     const totalsRows = [
//       {},
//       {
//         value: invoice.total_loads,
//         fontSize: 12,
//         leftBorderStyle: "thin",
//         align: "center",
//         fontWeight: "bold",
//         bottomBorderStyle: "thin",
//       },
//     ];

//     const totalsHeader = [
//       {},
//       {
//         value: "Loads",
//         fontWeight: "bold",
//         fontSize: 15,
//         leftBorderStyle: "thin",
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         align: "center",
//       },
//     ];

//     if (!invoice.is_asset) {
//       totalsHeader.push({
//         value: "Hauling Tons",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         align: "center",
//       });
//       totalsRows.push({
//         value: parseFloat(invoice.total_weight_tons.toFixed(2)),
//         fontSize: 12,
//         align: "center",
//         bottomBorderStyle: "thin",
//       });
//     }

//     totalsHeader.push({
//       value: "Total Freight $",
//       fontWeight: "bold",
//       fontSize: 15,
//       topBorderStyle: "thin",
//       bottomBorderStyle: "thin",
//       align: "center",
//     });
//     totalsRows.push({
//       value: parseFloat(invoice.freight_cost.toFixed(2)),
//       fontSize: 12,
//       align: "center",
//       bottomBorderStyle: "thin",
//     });

//     const endTotHeader = [
//       {
//         value: "Total FSC $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "Gross $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "Adjustments $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "Net $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "Not Invoiced Total $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//     ];
//     totalsHeader.push(...endTotHeader);
//     const data = [blankRow, totalsHeader];

//     const endToTotalsRows = [
//       {
//         value: parseFloat(invoice.fsc_cost.toFixed(2)),
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         bottomBorderStyle: "thin",
//       },
//       {
//         value: parseFloat((invoice.freight_cost + invoice.fsc_cost).toFixed(2)),
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//       },
//       {
//         value: parseFloat(adjustmentTotal.toFixed(2)),
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//       },
//       {
//         value: parseFloat(
//           (invoice.freight_cost + invoice.fsc_cost + adjustmentTotal).toFixed(
//             2,
//           ),
//         ),
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//       },
//       {
//         value: parseFloat(uninvoicedTotal.toFixed(2)),
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//       },
//     ];
//     totalsRows.push(...endToTotalsRows);
//     data.push(totalsRows);
//     const mileageHeader = [
//       {},
//       {
//         value: "Mileage",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         leftBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "Weight (tons)",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "Freight Rate $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "Freight $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "FSC Rate $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "FSC $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//       {
//         value: "Total $",
//         fontWeight: "bold",
//         fontSize: 15,
//         topBorderStyle: "thin",
//         bottomBorderStyle: "thin",
//         rightBorderStyle: "thin",
//         align: "center",
//       },
//     ];

//     const freightHeader = [
//       {
//         value: "Terminal",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "Product",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "PO Number",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "Ticket No",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//     ];

//     const endHeaders = [
//       {
//         value: "Approved Mileage",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "Net Weight (tons)",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "Freight ($)",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "Fuel Surcharge ($)",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "Gross ($)",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//     ];

//     var loadsHeader;
//     var newLoads = [];
//     var mileageBands = {};

//     loadsHeader = [
//       {},
//       {
//         value: "Load No",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "Delivery Date",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "Carrier",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//       {
//         value: "Driver",
//         fontWeight: "bold",
//         fontSize: 14,
//         align: "center",
//       },
//     ];
//     if (!invoice.is_asset) {
//       loadsHeader.push(...freightHeader);
//     }
//     loadsHeader.push(...endHeaders);

//     invoiceLoads.forEach((load) => {
//       let freightLoads = [
//         {
//           value: load.terminal_name,
//           fontSize: 12,
//           align: "center",
//         },
//         {
//           value: load.product_name,
//           fontSize: 12,
//           align: "center",
//         },
//         {
//           value: load.po_number,
//           fontSize: 12,
//           align: "center",
//         },
//         {
//           value: load.ticket_number,
//           fontSize: 12,
//           align: "center",
//         },
//       ];

//       let endLoads = [
//         {
//           value: load.mileage,
//           fontSize: 12,
//           align: "center",
//         },
//         {
//           value: parseFloat(load.weight_tons.toFixed(2)),
//           fontSize: 12,
//           type: Number,
//           align: "center",
//         },
//         {
//           value: parseFloat(load.freight_cost.toFixed(2)),
//           fontSize: 12,
//           type: Number,
//           align: "center",
//         },
//         {
//           value: parseFloat(load.fsc_cost.toFixed(2)),
//           fontSize: 12,
//           type: Number,
//           align: "center",
//         },
//         {
//           value: parseFloat(load.total_cost.toFixed(2)),
//           fontSize: 12,
//           type: Number,
//           align: "center",
//         },
//       ];
//       let delivered = DeliveredOn(load.delivered_date);
//       let newLoad;

//       newLoad = [
//         {},
//         {
//           value: load.load_no,
//           fontSize: 12,
//           align: "center",
//         },
//         {
//           value: delivered,
//           fontSize: 12,
//           align: "center",
//         },
//         {
//           value: load.carrier_name,
//           fontSize: 12,
//           align: "center",
//         },
//         {
//           value: load.driver_name,
//           fontSize: 12,
//           align: "center",
//         },
//       ];
//       if (!invoice.is_asset) {
//         newLoad.push(...freightLoads);
//       }
//       newLoad.push(...endLoads);

//       newLoads.push([...newLoad]);
//       if (!mileageBands[load.mileage]) {
//         mileageBands[load.mileage] = [
//           {
//             weight: load.weight_tons,
//             freight_per_ton: 0,
//             freight: load.freight_cost,
//             fsc_per_ton: 0,
//             unique_freight_rate: getRateFromMethod(
//               7,
//               load.weight_tons,
//               load.mileage,
//               load.freight_cost,
//             ).toFixed(2),
//             unique_fsc_rate: getRateFromMethod(
//               methodId,
//               load.weight_tons,
//               load.mileage,
//               load.fsc_cost,
//             ).toFixed(2),
//             fsc: load.fsc_cost,
//             total: load.freight_cost + load.fsc_cost,
//           },
//         ];
//       } else {
//         var m = mileageBands[load.mileage].filter(
//           (x) =>
//             getRateFromMethod(
//               7,
//               load.weight_tons,
//               load.mileage,
//               load.freight_cost,
//             ).toFixed(2) === x.unique_freight_rate &&
//             getRateFromMethod(
//               methodId,
//               load.weight_tons,
//               load.mileage,
//               load.fsc_cost,
//             ).toFixed(2) === x.unique_fsc_rate,
//         );
//         if (m.length > 0) {
//           m[0].weight = m[0].weight + load.weight_tons;
//           m[0].freight = m[0].freight + load.freight_cost;
//           m[0].fsc = m[0].fsc + load.fsc_cost;
//           m[0].total = m[0].total + load.freight_cost + load.fsc_cost;
//         } else {
//           mileageBands[load.mileage].push({
//             weight: load.weight_tons,
//             freight_per_ton: 0,
//             freight: load.freight_cost,
//             fsc_per_ton: 0,
//             unique_freight_rate: getRateFromMethod(
//               7,
//               load.weight_tons,
//               load.mileage,
//               load.freight_cost,
//             ).toFixed(2),
//             unique_fsc_rate: getRateFromMethod(
//               methodId,
//               load.weight_tons,
//               load.mileage,
//               load.fsc_cost,
//             ).toFixed(2),
//             fsc: load.fsc_cost,
//             total: load.freight_cost + load.fsc_cost,
//           });
//         }
//       }
//     });

//     data.push(blankRow, blankRow);
//     data.push([
//       {},
//       {
//         value: "Mileages",
//         fontSize: 20,
//         align: "center",
//         span: 7,
//       },
//     ]);
//     data.push(mileageHeader);
//     for (const [key, value] of Object.entries(mileageBands)) {
//       var keys = [];
//       var i = 0;
//       for (const [, v] of Object.entries(value)) {
//         if (v.weight > 0) {
//           v.freight_per_ton = parseFloat(v.unique_freight_rate);
//           v.fsc_per_ton = parseFloat(v.unique_fsc_rate);
//         }
//         keys.push(key);
//         var mileageBand = [];
//         if (i === 0) {
//           mileageBand.push(
//             {},
//             {
//               value: key,
//               fontSize: 15,
//               topBorderStyle: "thin",
//               bottomBorderStyle: "thin",
//               rightBorderStyle: "thin",
//               leftBorderStyle: "thin",
//               align: "center",
//             },
//           );
//         } else if (keys[i - 1] !== keys[i]) {
//           mileageBand.push(
//             {},
//             {
//               value: key,
//               fontSize: 15,
//               topBorderStyle: "thin",
//               bottomBorderStyle: "thin",
//               rightBorderStyle: "thin",
//               leftBorderStyle: "thin",
//               align: "center",
//             },
//           );
//         } else {
//           mileageBand.push(
//             {},
//             {
//               value: "",
//               fontSize: 15,
//               topBorderStyle: "thin",
//               bottomBorderStyle: "thin",
//               rightBorderStyle: "thin",
//               leftBorderStyle: "thin",
//               align: "center",
//             },
//           );
//         }
//         mileageBand.push(
//           {
//             value: v.weight,
//             fontSize: 15,
//             type: Number,
//             topBorderStyle: "thin",
//             bottomBorderStyle: "thin",
//             rightBorderStyle: "thin",
//             align: "center",
//           },
//           {
//             value: parseFloat(v.freight_per_ton.toFixed(2)),
//             fontSize: 15,
//             type: Number,
//             topBorderStyle: "thin",
//             bottomBorderStyle: "thin",
//             rightBorderStyle: "thin",
//             align: "center",
//           },
//           {
//             value: parseFloat(v.freight.toFixed(2)),
//             fontSize: 15,
//             type: Number,
//             topBorderStyle: "thin",
//             bottomBorderStyle: "thin",
//             rightBorderStyle: "thin",
//             align: "center",
//           },
//           {
//             value: parseFloat(v.fsc_per_ton.toFixed(2)),
//             fontSize: 15,
//             type: Number,
//             topBorderStyle: "thin",
//             bottomBorderStyle: "thin",
//             rightBorderStyle: "thin",
//             align: "center",
//           },
//           {
//             value: parseFloat(v.fsc.toFixed(2)),
//             fontSize: 15,
//             type: Number,
//             topBorderStyle: "thin",
//             bottomBorderStyle: "thin",
//             rightBorderStyle: "thin",
//             align: "center",
//           },
//           {
//             value: parseFloat(v.total.toFixed(2)),
//             fontSize: 15,
//             type: Number,
//             topBorderStyle: "thin",
//             bottomBorderStyle: "thin",
//             rightBorderStyle: "thin",
//             align: "center",
//           },
//         );
//         data.push(mileageBand);
//         i += 1;
//       }
//     }

//     data.push(blankRow, blankRow);

//     if (adjustments && adjustments.adjustment_fields) {
//       data.push(blankRow, blankRow);
//       data.push([
//         {},
//         {
//           value: "Adjustments",
//           fontWeight: "bold",
//           fontSize: 20,
//           align: "center",
//           span: 5,
//         },
//       ]);
//       data.push([
//         {},
//         {
//           value: "Item",
//           fontWeight: "bold",
//           fontSize: 15,
//           leftBorderStyle: "thin",
//           topBorderStyle: "thin",
//           bottomBorderStyle: "thin",
//           align: "center",
//         },
//         {
//           value: "Type",
//           fontWeight: "bold",
//           fontSize: 15,
//           topBorderStyle: "thin",
//           bottomBorderStyle: "thin",
//           align: "center",
//         },
//         {
//           value: "Amount $",
//           fontWeight: "bold",
//           fontSize: 15,
//           topBorderStyle: "thin",
//           bottomBorderStyle: "thin",
//           align: "center",
//         },
//         {
//           value: "Date",
//           fontWeight: "bold",
//           fontSize: 15,
//           topBorderStyle: "thin",
//           bottomBorderStyle: "thin",
//           align: "center",
//         },
//         {
//           value: "Comments",
//           fontWeight: "bold",
//           fontSize: 15,
//           topBorderStyle: "thin",
//           bottomBorderStyle: "thin",
//           rightBorderStyle: "thin",
//           align: "center",
//         },
//       ]);
//       adjustments.adjustment_fields.forEach((f) => {
//         let adjDate = getDateWithoutTimestamp(f.date_of_adjustment);
//         data.push([
//           {},
//           {
//             value: f.field_name,
//             fontSize: 12,
//             leftBorderStyle: "thin",
//             align: "center",
//             fontWeight: "bold",
//             bottomBorderStyle: "thin",
//           },
//           {
//             value: f.is_credit ? "Credit" : "Charge",
//             fontSize: 12,
//             align: "center",
//             bottomBorderStyle: "thin",
//           },
//           {
//             value: parseFloat(f.field_value),
//             fontSize: 12,
//             type: Number,
//             align: "center",
//             bottomBorderStyle: "thin",
//           },
//           {
//             value: adjDate,
//             fontSize: 12,
//             align: "center",
//             bottomBorderStyle: "thin",
//           },
//           {
//             value: f.adjustment_comments,
//             fontSize: 12,
//             align: "center",
//             bottomBorderStyle: "thin",
//             rightBorderStyle: "thin",
//           },
//         ]);
//       });
//       data.push([
//         {},
//         {
//           value: "Total",
//           fontSize: 15,
//           leftBorderStyle: "thin",
//           align: "center",
//           fontWeight: "bold",
//           bottomBorderStyle: "thin",
//         },
//         { bottomBorderStyle: "thin" },
//         {
//           value: parseFloat(adjustments.invoice_adjustment.total_adjustment),
//           fontSize: 15,
//           fontWeight: "bold",
//           type: Number,
//           align: "center",
//           bottomBorderStyle: "thin",
//         },
//         {
//           bottomBorderStyle: "thin",
//         },
//         {
//           bottomBorderStyle: "thin",
//           rightBorderStyle: "thin",
//         },
//       ]);
//     }

//     var uninvoicedHeader;
//     if (uninvoicedLoads) {
//       data.push([
//         {},
//         {
//           value: "Loads Not Invoiced",
//           fontWeight: "bold",
//           fontSize: 20,
//           align: "center",
//           span: 13,
//         },
//       ]);
//       uninvoicedHeader = [
//         {},
//         {
//           value: "Load No",
//           fontWeight: "bold",
//           fontSize: 14,
//           align: "center",
//         },
//         {
//           value: "Duplicate Tickets Load #s",
//           fontWeight: "bold",
//           fontSize: 14,
//           align: "center",
//         },
//         {
//           value: "Ticket Is Missing",
//           fontWeight: "bold",
//           fontSize: 14,
//           align: "center",
//         },
//         {
//           value: "Locked Reason",
//           fontWeight: "bold",
//           fontSize: 14,
//           align: "center",
//         },
//         {
//           value: "Approval Status",
//           fontWeight: "bold",
//           fontSize: 14,
//           align: "center",
//         },
//         {
//           value: "Delivery Date",
//           fontWeight: "bold",
//           fontSize: 14,
//           align: "center",
//         },
//         {
//           value: "Carrier",
//           fontWeight: "bold",
//           fontSize: 14,
//           align: "center",
//         },
//         {
//           value: "Driver",
//           fontWeight: "bold",
//           fontSize: 14,
//           align: "center",
//         },
//       ];
//       if (!invoice.is_asset) {
//         uninvoicedHeader.push(...freightHeader);
//       }
//       uninvoicedHeader.push(...endHeaders);

//       data.push(uninvoicedHeader);

//       uninvoicedLoads.forEach((load) => {
//         let freightLoads = [
//           {
//             value: load.terminal_name,
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: load.product_name,
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: load.po_number,
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: load.ticket_number,
//             fontSize: 12,
//             align: "center",
//           },
//         ];

//         let endLoads = [
//           {
//             value: load.mileage,
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: parseFloat(load.weight_tons.toFixed(2)),
//             fontSize: 12,
//             type: Number,
//             align: "center",
//           },
//           {
//             value: parseFloat(load.freight_cost.toFixed(2)),
//             fontSize: 12,
//             type: Number,
//             align: "center",
//           },
//           {
//             value: parseFloat(load.fsc_cost.toFixed(2)),
//             fontSize: 12,
//             type: Number,
//             align: "center",
//           },
//           {
//             value: parseFloat(load.total_cost.toFixed(2)),
//             fontSize: 12,
//             type: Number,
//             align: "center",
//           },
//         ];
//         let delivered = DeliveredOn(load.delivered_date);
//         let newLoad;

//         newLoad = [
//           {},
//           {
//             value: load.load_no,
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value:
//               load.duplicate_tickets.length > 1
//                 ? [...load.duplicate_tickets.slice(1)]
//                 : "",
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: load.ticket_is_missing ? "Yes" : "",
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: load.locked_reason,
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: load.propconnect_approval_status,
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: delivered,
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: load.carrier_name,
//             fontSize: 12,
//             align: "center",
//           },
//           {
//             value: load.driver_name,
//             fontSize: 12,
//             align: "center",
//           },
//         ];
//         if (!invoice.is_asset) {
//           newLoad.push(...freightLoads);
//         }
//         newLoad.push(...endLoads);
//         data.push(newLoad);
//       });
//     }

//     data.push(blankRow, blankRow);

//     data.push([
//       {},
//       {
//         value: "Invoiced Loads",
//         fontWeight: "bold",
//         fontSize: 20,
//         align: "center",
//         span: 13,
//       },
//     ]);

//     data.push(loadsHeader);
//     data.push(...newLoads);

//     let freightGap = [{}, {}, {}, {}];

//     let endTotal = [
//       {},
//       {},
//       {},
//       {},
//       {
//         value: parseFloat(invoice.total_weight_tons.toFixed(2)),
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         fontWeight: "bold",
//       },
//       {
//         value: parseFloat(invoice.freight_cost.toFixed(2)),
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         fontWeight: "bold",
//       },
//       {
//         value: parseFloat(invoice.fsc_cost.toFixed(2)),
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         fontWeight: "bold",
//       },
//       {
//         value: parseFloat((invoice.freight_cost + invoice.fsc_cost).toFixed(2)),
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         fontWeight: "bold",
//       },
//     ];
//     let loadTotals;

//     loadTotals = [
//       {
//         value: "Totals",
//         fontSize: 12,
//         align: "center",
//         fontWeight: "bold",
//       },
//       {
//         value: invoice.total_loads,
//         fontSize: 12,
//         type: Number,
//         align: "center",
//         fontWeight: "bold",
//       },
//     ];
//     if (!invoice.is_asset) {
//       loadTotals.push(...freightGap);
//     }
//     loadTotals.push(...endTotal);

//     data.push(loadTotals);
//     await writeXlsxFile(data, {
//       columns,
//       fileName,
//     });
//   }
// };
